import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

/** Compact share glyph + label (parent usually owns the clickable chrome). */
const ShareButton = ({ onClick, size = 16 }) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px',
        fontSize: size,
        color: 'inherit',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        userSelect: 'none',
        lineHeight: 1,
      }}
    >
      <FontAwesomeIcon icon={faPaperPlane} aria-hidden />
      <span className="post-action-text" style={{ fontSize: 15, fontWeight: 600 }}>
        Share
      </span>
    </div>
  );
};

export default ShareButton;
